<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <el-input
        v-model="tableParams.searchKey"

        clearable
        placeholder="请输入账号或账号名"
      />
      <el-select
        v-model="tableParams.roleId"
        clearable
        placeholder="请选择角色名字"

      >
        <el-option
          v-for="(item, index) in optionList"
          :label="item.roleName"
          :value="item.roleId"
        ></el-option>
      </el-select>
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px"
      >
        <el-button @click="add" type="primary" size="small">新增</el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row
        size="small"
        class="js-table"
        style="width: 100%"
        @sort-change="sortChange"
      >
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
          align="center"
          :sortable="
            v.field === 'showSmt' ||
            v.field === 'timeKey' ||
            v.field === 'appBundle' ||
            v.field === 'keyword' ||
            v.field === 'contactPhone' ||
            v.field === 'hit' ||
            v.field === 'winPrice' ||
            v.field === 'auctionPrice' ||
            v.field === 'clkSmt' ||
            v.field === 'expensesAge' ||
            v.field === 'incomeAge' ||
            v.field === 'clkAvg'
          "
        >
          <template v-slot="scope">
            <el-switch
              v-if="v.field === 'isEnable'"
              v-model="scope.row.isEnable"
              active-color="#13ce66"
              :active-value="0"
              :inactive-value="1"
              @change="onChange(scope.row)"
            />
            <span v-else-if="v.field === 'a'">
              <el-button
                type="text"
                size="small"
                @click="channelTrans(scope.row)"
                >客户管理</el-button
              >
            </span>
            <span v-else-if="v.field === 'b'">
              <el-button type="text" size="small" @click="dspTrans(scope.row)"
                >客户管理</el-button
              >
            </span>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="180">
          <template v-slot="scope" align="center">
            <el-button @click="update(scope.row)" type="success" size="mini"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <m-form @submit="submit" ref="form" :title="type + '编辑'" />

      <el-dialog v-model="visible" width="400">
        <div>
          <el-transfer
            filterable
            v-model="clientArr"
            :data="listData"
            :props="{ key: 'id', label: 'name' }"
            :titles="['待添加账号', '已添加账号']"
            :button-texts="['到左边', '到右边']"
          ></el-transfer>
          <div style="text-align: center">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="saveData">保存</el-button>
          </div>
        </div>
      </el-dialog>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>
  </div>
</template>

<script>
import TableColumn from '@/components/TableColumn'
import SearchDspSelect from '@/components/SearchDspSelect'
import BaseDatePicker from '@/components/BaseDatePicker'
import downExcelMixin from '@/mixins/downExcel'
import initTableMixin from '@/mixins/initTable'
import mForm from './form'
import {
  updateStatus,
  sysUserRoleList,
  clientList,
  editClient
} from "@/api/jurisdiction/administrator/index";

export default {
  name: 'Manage/keyword/appWord',
  components: {
    TableColumn,
    SearchDspSelect,
    BaseDatePicker,
    mForm,
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      columns: [
        { field: 'accountId', title: '序号' },
        { field: 'account', title: '账号' },
        { field: 'roleName', title: '所属角色' },
        { field: 'a', title: '渠道客户管理' },
        { field: 'b', title: 'DSP客户管理' },
        { field: 'createTime', title: '创建时间' },
        { field: 'isEnable', title: '状态' },
      ],
      clientArr: [],
      type: '',
      tey: false,
      optionList: [],
      visible: false,
      listData: [],
      cForm: {}
    }
  },
  created() {
    sysUserRoleList().then(res => {
      this.optionList = res.data
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  provide() {
    return {
      init: this.init
    }
  },
  methods: {
    beforeInit() {
      this.tableUrl = '/admin/list'
      return true
    },
    changeDate(date) {
      this.tableParams.startTime = date.startTime
      this.tableParams.endTime = date.endTime
    },
    onChange(data) {
      updateStatus({
        accountId: data.accountId,
        isEnable: data.isEnable
      })
    },
    add() {
      this.type = '新增用户信息'
      this.$refs.form.show()
    },
    update(row) {
      this.type = '修改用户信息'
      this.$refs.form.show(row)
    },
    sortChange(column, prop, order) {
      if (column.order === 'ascending') {
        this.tableParams.asc = column.prop
        this.tableParams.desc = ''
      } else if (column.order === 'descending') {
        this.tableParams.desc = column.prop
        this.tableParams.asc = ''
      }
      this.init()
    },
    channelTrans (row) {
      row.type = 'channel'
      this.cForm = Object.assign({},row)
      clientList({accountId: row.accountId, type: 'channel'})
      .then(res => {
        if (res.code === 200) {
          this.listData = res.data.unRelationList.concat(res.data.relationList)
          this.clientArr = res.data.relationList.map(item => item.id)
          this.visible = true
        }
      })
    },
    cancel () {
      this.visible = false
      this.listData = []
      this.clientArr = []
      this.cForm = {}
    },
    saveData () {
      editClient ({accountId: this.cForm.accountId, type:this.cForm.type,ids: this.clientArr})
      .then(res => {
        if (res.code === 200) {
          this.$message.success("保存成功!");
          this.cancel()
        }
      })
    },
    dspTrans (row) {
      row.type = 'dsp'
      this.cForm = Object.assign({},row)
      clientList({accountId: row.accountId, type: 'dsp'})
      .then(res => {
        if (res.code === 200) {
          this.listData = res.data.unRelationList.concat(res.data.relationList)
          this.clientArr = res.data.relationList.map(item => item.id)
          this.visible = true
        }
      })
    },
    removeBlank(val, name) {
      this.tableParams[name] = val.replace(/^\s+|\s+$/gm, '')
    },
    submit() {
      this.init()
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
